angular.module('confRegistrationWebApp').constant('expenseTypesConstants', {
  REGISTRATION: 'Registration',
  MISCELLANEOUS_ITEM: 'Misc. Item',
  CHILDCARE: 'Childcare',
  STAFF_TAXABLE_ITEM: 'Staff Taxable Expense',
});

angular.module('confRegistrationWebApp').constant('ruleTypeConstants', {
  SHOW_QUESTION: 'SHOW_QUESTION',
  FORCE_SELECTION: 'FORCE_SELECTION',
  SHOW_OPTION: 'SHOW_OPTION',
});
